import { render, staticRenderFns } from "./PushRecords.vue?vue&type=template&id=2efc6550"
import script from "./PushRecords.vue?vue&type=script&lang=js"
export * from "./PushRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports